<template>
    <v-dialog v-model="showModal" width="auto" persistent :max-width="maxWidth">
        <v-card>
            <v-card-title class="d-flex align-center justify-center">
                <slot name="title"></slot>
            </v-card-title>
            <v-card-text class="pb-4">
                <slot></slot>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    props: {
        showModal: Boolean,
        maxWidth: {
            type: [String, Number],
            default: '800'
        }
    }
};
</script>
